import axios from "../Helper/axios";
import { URL } from "../Helper/baseURL";

export const uploadFile = (data, filename, onProgress) => {
    const formData = new FormData();
    formData.append('file',data, filename);
    return axios.post(URL + 'files/fileController/add', formData, {
        onUploadProgress: onProgress,
    });
};